/*
 * Las lineas de trabajo: ramos de novia, matrimonios petit, y las demas.
 *
 * Viven enteras en servicios.json —titulo, texto y fotos juntos— y eso es lo
 * que edita Valentina desde /admin. Antes estaban partidas en dos: el texto en
 * contenido.json y la foto en fotos.json, unidas por un `id` cableado aca. Esa
 * llave existia solo para eso, asi que al guardar las fotos adentro de cada
 * servicio se pudo sacar: ahora agregar, borrar o reordenar una linea es mover
 * un elemento de una lista, y no hay ningun id que quede apuntando a la nada.
 *
 * La numeracion sale del orden, no se escribe: la primera es 01.
 */

import datos from './servicios.json';
import ruta from './ruta';

const dosDigitos = (i) => String(i + 1).padStart(2, '0');

const foto = (entrada) => ({
  src: ruta(entrada.archivo),
  alt: entrada.alt,
  orientacion: entrada.orientacion ?? 'retrato',
});

/*
 * La raiz del JSON es un objeto y no una lista suelta porque es lo que espera
 * el panel: en su config las lineas son un campo llamado `servicios` dentro
 * del archivo, asi que si la raiz fuera la lista misma no encontraria la
 * llave y mostraria la seccion vacia, con el sitio lleno. Y guardar esa
 * seccion vacia borraria las lineas.
 */
export default (datos.servicios ?? []).map((servicio, i) => ({
  numero: dosDigitos(i),
  titulo: servicio.titulo,
  texto: servicio.texto,
  /* `fila` las pone una al lado de la otra; `carrusel` deja arrastrarlas. */
  vista: servicio.vista ?? 'fila',
  /* Si su titulo aparece bajo la marca, arriba de todo. */
  portada: servicio.portada === true,
  fotos: (servicio.fotos ?? []).map(foto),
}));
